export const contractBillingFrequency = ["Monthly", "Quarterly", "Semi-Annually", "Annually", "OneTime"];
export const contractType = ["Month-To-Month", "Annual"];
export const productType = [
  { key: "Licenses", displayName: "Licenses" },
  { key: "Platform", displayName: "Platform" },
  { key: "ProfessionalServices", displayName: "Professional Services" },
];
export const alertTypes = [
  { key: "Actual", displayName: "Actual" },
  { key: "Forecasted", displayName: "Forecasted" },
];

export const unitPriceType = [{ key: "per month" }, { key: "per year" }, { key: "per contract tenure" }];

export const nonCurrencyValues = ["No. of Applications"];
export const currency = [
  "AED",
  "AFN",
  "ALL",
  "AMD",
  "ARS",
  // "AU",
  "AUD",
  "AWG",
  "AZN",
  "BAM",
  "BBD",
  "BDT",
  "BF",
  "BGN",
  "BHD",
  "BIF",
  "BMD",
  "BND",
  "BOB",
  "BRL",
  "BSD",
  "BTN",
  "BWP",
  "BYN",
  "BZD",
  "CAD",
  "CDF",
  "CH",
  "CHF",
  "CI",
  "CLP",
  "CM",
  "CNY",
  "COP",
  "CRC",
  "CUC",
  "CVE",
  "CX",
  "CY",
  "DE",
  "DJF",
  "DKK",
  "DM",
  "DOP",
  "DZD",
  "EC",
  "EGP",
  "ERN",
  "ES",
  "ETB",
  "EUR",
  "FI",
  "FJD",
  "FKP",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GBP",
  "GD",
  "GEL",
  "GGP",
  "GHS",
  "GIP",
  "GL",
  "GMD",
  "GNF",
  "GP",
  "GR",
  "GS",
  "GTQ",
  "GU",
  "GW",
  "GYD",
  "HKD",
  "HM",
  "HNL",
  "HTG",
  "HUF",
  "IDR",
  "IE",
  "ILS",
  "IMP",
  "INR",
  "IQD",
  "IRR",
  "ISK",
  "IT",
  "JEP",
  "JMD",
  "JOD",
  "JPY",
  "KES",
  "KGS",
  "KHR",
  "KMF",
  "KN",
  "KPW",
  "KRW",
  "KWD",
  "KYD",
  "KZT",
  "LAK",
  "LBP",
  "LC",
  "LKR",
  "LRD",
  "LSL",
  "LTL",
  "LU",
  "LV",
  "LYD",
  "MA",
  "MAD",
  "MC",
  "MDL",
  "ME",
  "MGA",
  "MKD",
  "ML",
  "MMK",
  "MNT",
  "MOP",
  "MRU",
  "MS",
  "MT",
  "MUR",
  "MVR",
  "MWK",
  "MXN",
  "MYR",
  "MZN",
  "NAD",
  "NC",
  "NE",
  "NF",
  "NGN",
  "NIO",
  "NL",
  "NO",
  "NOK",
  "NPR",
  "NR",
  "NU",
  // "NZ",
  "NZD",
  "OMR",
  "PAB",
  "PEN",
  "PGK",
  "PHP",
  "PKR",
  "PLN",
  "PM",
  "PS",
  "PYG",
  "RE",
  "RON",
  "RSD",
  // "RU",
  "RUB",
  "RWF",
  "SAR",
  "SBD",
  "SCR",
  "SDG",
  "SEK",
  "SGD",
  "SHP",
  "SJ",
  "SK",
  "SM",
  "SN",
  "SOS",
  "SRD",
  "SSP",
  "STN",
  "SX",
  "SYP",
  "SZL",
  "TG",
  "THB",
  "TJS",
  "TK",
  "TMT",
  "TND",
  "TOP",
  "TRY",
  "TTD",
  "TV",
  "TWD",
  "TZS",
  "UAH",
  "UGX",
  "UMI",
  // "US",
  "USD",
  "UYU",
  "VC",
  "VES",
  "VND",
  "VUV",
  "WF",
  "WST",
  "XAF",
  "XCD",
  "XOF",
  "XPF",
  "YER",
  "YT",
  "ZAR",
  "ZMW",
  "ZWL",
];

export const MENUITEMS = {
  PC_DASHBOARD: "Work Order Dashboard",
  PC_WORK_ORDER: "Work Order",
  PC_WORK_ORDER_APPROVAL: "Work Order Approval",
  PC_APPROVAL_MANAGEMENT: "Approval Management",
  PC_USER_MANAGEMENT: "Work Order User Management",
  PC_MANAGE_CATALOG: "Manage Catalog",
};

export const subsidiaries = [
  "Malaysia Airports (Sepang) Sdn. Bhd. - Terminal 1",
  "Malaysia Airports (Sepang) Sdn. Bhd. - Terminal 2",
  "Malaysia Airports Sdn. Bhd. - Penang",
  "Malaysia Airports Sdn. Bhd. - Kota Kinabalu",
  "Malaysia Airports Sdn. Bhd. - Kuching",
  "Malaysia Airports Sdn. Bhd. - Langkawi",
  "Malaysia Airports Sdn. Bhd. - Miri",
  "Malaysia Airports Sdn. Bhd. - Subang",
  "Malaysia Airports Sdn. Bhd. - Alor Setar",
  "Malaysia Airports Sdn. Bhd. - Kota Bharu",
  "Malaysia Airports Sdn. Bhd. - Kuala Terengganu",
  "Malaysia Airports Sdn. Bhd. - Kuantan",
  "Malaysia Airports Sdn. Bhd. - Ipoh",
  "Malaysia Airports Sdn. Bhd. - Bintulu",
  "Malaysia Airports Sdn. Bhd. - Labuan",
  "Malaysia Airports Sdn. Bhd. - Sandakan",
  "Malaysia Airports Sdn. Bhd. - Sibu",
  "Malaysia Airports Sdn. Bhd. - Tawau",
  "Malaysia Airports Sdn. Bhd. - Limbang",
  "Malaysia Airports Sdn. Bhd. - Melaka",
  "Malaysia Airports Sdn. Bhd. - Lahad Datu",
  "Malaysia Airports Sdn. Bhd. - Mukah",
  "Malaysia Airports Sdn. Bhd. - Mulu",
  "Malaysia Airports (Niaga) Sdn. Bhd",
  "Malaysia Airports Consultancy Services Sdn. Bhd",
  "MAB Agriculture-Horticulture Sdn. Bhd",
  "Urusan Teknologi Wawasan Sdn. Bhd",
  "KLIA Aeropolis Sdn. Bhd",
  "Malaysia Airports (Properties) Sdn. Bhd",
];

export const commercialSubsidiary = ["Malaysia Airports Sdn Bhd.", "Malaysia Airports (Sepang) Sdn. Bhd."];

export const airportSepang = ["KL International Airport, Terminal 1", "KL International Airport, Terminal 2"];

export const airportSdnBhd = [
  "Penang International Airport",
  "Kota Kinabalu International Airport",
  "Kuching International Airport",
  "Langkawi International Airport",
  "Miri Airport",
  "Subang Skypark",
  "Alor Setar Airport",
  "Kota Bharu Airport",
  "Kuala Terengganu Airport",
  "Kuantan Airport",
  "Ipoh Airport",
  "Bintulu Airport",
  "Labuan Airport",
  "Sandakan Airport",
  "Sibu Airport",
  "Tawau Airport",
  "Limbang Airport",
  "Melaka Airport",
  "Lahad Datu Airport",
  "Mukah Airport",
  "Mulu Airport",
  "MASB HQ",
];

export const taxList = ["Exclusive of SST", "Inclusive of SST", "Exclusive of WHT", "Inclusive of WHT"];

export const designation = ["Manager", "Senior Manager", "Executive", "Senior Executive", "Officer"];
export const airportDesignation = ["Senior Manager", "Manager", "Senior Executive", "Executive", "Officer"];

export const nonAirportDesignation = ["Senior Manager", "Manager"]

export const department = ["one", "two"];

export const mdReviewer = ["R2", "R3", "GCEO", "MD"];
export const gcfoReviewer = ["R3", "R3", "CPO", "GCFO", "GCOO"];

export const headSubsidiary = ["R2", "R3", "CPO", "Head of Subsidiary"];
export const budget = {
  budgetOne: "500000",
  budgetTwo: "499999",
};

export const deaprtmentRoles = ["Finance", "PCD", "Technical"];

export const timezone = "Asia/Kuala_Lumpur";

export const docusignStatus = [
  "created",
  "sent",
  // "draft",
  // "delivered",
  "completed",
  "voided",
  "declined",
  "expired",
];

export const spaBudget = ["OPEX", "CAPEX", "OPEX & CAPEX"];
export const spaFilterBudget = ["OPEX", "CAPEX", "OPEX & CAPEX", "Uncategorized"];

export const spaPaper = ["Award", "Strategy"];
export const spaFilterPaper = ["Award", "Strategy", "Uncategorized"];